import { createBrowserRouter, Navigate } from 'react-router-dom';

// routes
import AuthenticationRoutes from './MaintenanceRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import { RouteObject } from 'react-router-dom';
import { DASHBOARD_PATH } from 'config';

// ==============================|| ROUTING RENDER ||============================== //

const notFoundRoute: RouteObject = {
  path: '*',
  element: <Navigate to={DASHBOARD_PATH} replace />,
};

const router = createBrowserRouter([LoginRoutes, MainRoutes, AuthenticationRoutes, notFoundRoute], {
  basename: import.meta.env.VITE_APP_BASE_NAME,
});

export default router;
